import { staticContentPath } from "common/static_content_common";
import VideoUpload from "components/common/video/VideoForm/VideoUpload";
import VideoPlay from "components/common/video/VideoPlay";
import styled from "styled-components";

const TestPage = () => {
  // const filePath = "http://localhost:3011/static-content/test_01-1.mp4";
  const filePath = staticContentPath("test_01-1.mp4");
  return (
    <DivTest>
      <div>Test</div>
      <VideoPlay
        filePath={filePath}
        autoPlay={true}
        muted={true}
        width={500}
        currentTime={8}
      />
    </DivTest>
  );
};

const DivTest = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-left: 2rem;
`;

export default TestPage;
